(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["password-collection-header"]) return;
  try {
    
    if(window.location.href.includes("/collections") &&
    document.getElementById('id_tag') != null && localStorage.getItem(document.getElementById("id_tag").innerText+"") == "false"
    && !document.getElementById('id_tag').innerText.includes("password")){
        window.location.href = "https://www.perchhome.com/";
    } else if(window.location.href.includes("/products") &&
      document.getElementById('id_tag') != null &&
      document.getElementById('id_tag').innerText.includes("password") &&
      localStorage.getItem(document.getElementById("id_tag").innerText+"") != "true" ){
        window.location.href = "https://www.perchhome.com/";
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password-protected-collection"]) return;
  try {
    
  document.getElementById('passwordForm').addEventListener('submit', function (e) {
    e.preventDefault();
      const enteredPassword = document.querySelector('input[name="pw"]').value;
      let checkValue = document.querySelector(".password_form").dataset.element.split("_")[1];
      if (enteredPassword == checkValue) {
        localStorage.setItem(document.getElementById("id_tag").innerText+"", "true");
        location.reload();
      } else {
        localStorage.setItem(document.getElementById("id_tag").innerText+"", "false");
        document.querySelector("#error-message").setAttribute("style","display:block;color: red;");
      }
    });

    if(localStorage.getItem(document.getElementById("id_tag").innerText+"") == "true") {
      document.querySelector(".password_protected").setAttribute("style","display:block;");
      document.querySelector(".password_form").innerHTML="";
    } else if (localStorage.getItem(document.getElementById("id_tag").innerText+"") == "false"){
      document.querySelector(".password_protected").innerHTML="";
    }

  } catch(e) { console.error(e); }
})();
      })();
